/* eslint-disable */
import { PureComponent } from "react";
import PropTypes from "prop-types";

class ZendeskChat extends PureComponent {
	componentDidMount() {
		this.zendeskChat();
		if (document.getElementById("launcher"))
			document.getElementById("launcher").style.visibility = "visible";

		if (document.getElementById("webWidget"))
			document.getElementById("webWidget").style.visibility = "visible";
	}

	componentWillUnmount() {
		if (document.getElementById("launcher") && window.location.href.includes("/onboard/login"))
			document.getElementById("launcher").style.visibility = "hidden";

		if (document.getElementById("webWidget") && window.location.href.includes("/onboard/login"))
			document.getElementById("webWidget").style.visibility = "hidden";
	}

	zendeskChat = () => {
		const script = document.createElement("script");
		const SNIPPET_KEY = "79df3a39-f340-479f-b241-7c407e143a1f";

		script.src = `https://static.zdassets.com/ekr/snippet.js?key=${SNIPPET_KEY}`;
		script.async = true;
		script.id = "ze-snippet";

		document.body.appendChild(script);
	};

	render() {
		return null;
	}
}

export default ZendeskChat;
